import { useEffect, useState } from "react";
import QRCode from "qrcode";
import WebApp from "@twa-dev/sdk";

async function copyText(text: string): Promise<boolean> {
  try {
    const tg = WebApp as unknown as {
      copyTextToClipboard?: (t: string) => void;
      HapticFeedback?: { notificationOccurred: (t: string) => void };
    };
    if (typeof tg.copyTextToClipboard === "function") {
      tg.copyTextToClipboard(text);
      tg.HapticFeedback?.notificationOccurred("success");
      return true;
    }
  } catch {
    /* fall through */
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through */
  }

  try {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "fixed";
    el.style.left = "-9999px";
    el.style.top = "0";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.focus();
    el.select();
    el.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}

export function ConnectModal(props: {
  code: string;
  qrPayload: string;
  onClose: () => void;
}) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(props.qrPayload, {
      margin: 1,
      width: 220,
      color: { dark: "#1a1028", light: "#ffffff" },
    }).then((url) => {
      if (alive) setDataUrl(url);
    });
    return () => {
      alive = false;
    };
  }, [props.qrPayload]);

  async function handleCopy() {
    setCopyError(null);
    const ok = await copyText(props.code);
    if (ok) {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } else {
      setCopyError("Не удалось скопировать — выделите код вручную");
    }
  }

  return (
    <div className="modal-backdrop" onClick={props.onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Axiome Connect</h3>
        <p className="hint">
          Отсканируйте QR в Axiome Wallet или скопируйте код и вставьте в «Enter
          connection code».
        </p>
        <div className="qr-wrap">
          {dataUrl ? <img src={dataUrl} alt="QR Axiome Connect" width={220} height={220} /> : null}
        </div>

        <button
          type="button"
          className="code-box"
          onClick={handleCopy}
          aria-label="Скопировать код подключения"
        >
          <span className="code-label">Код подключения</span>
          <input
            className="code-input"
            readOnly
            value={props.code}
            onFocus={(e) => e.currentTarget.select()}
            onClick={(e) => {
              e.stopPropagation();
              e.currentTarget.select();
            }}
          />
          <span className="code-hint">{copied ? "Скопировано" : "Нажмите, чтобы скопировать"}</span>
        </button>

        <div className="cta-row" style={{ marginTop: 12 }}>
          <button className="btn btn-primary" style={{ flex: 1 }} onClick={handleCopy}>
            {copied ? "Скопировано ✓" : "Копировать код"}
          </button>
          <button className="btn btn-ghost" style={{ flex: 1 }} onClick={props.onClose}>
            Отмена
          </button>
        </div>
        {copyError ? <p className="status err">{copyError}</p> : null}
      </div>
    </div>
  );
}
